import {
    VuexModule,
    Mutation,
    Action, Module
  } from 'vuex-module-decorators'
  import { AxiosError, AxiosResponse } from "axios";
  import Vue from "vue";
import { NotificationList } from '@/models';
//   import { ORSchedule } from '@/models';
  
@Module({ namespaced: true})
class Notification extends VuexModule {

    // notificationList: any;
    public notificationList : any = {};

   
    @Mutation
     public setAllNotification(notifications: Array<NotificationList>): void {
        this.notificationList = []; 
        this.notificationList = notifications;
        this.notificationList.sort((a, b) => {
            if(a.timestamp < b.timestamp) return 1;
            if(a.timestamp > b.timestamp) return -1;
            return 0;
        });
     }

    // ACTIONS
    @Action({rawError: true})
    public getAllNotifications(userId: string): void {
        const api = `${process.env.VUE_APP_BASE_API_URL}/Notifications/${userId}`;

        return Vue.$net
            .get(api)
            .then((res: AxiosResponse) => {
                this.context.commit('setAllNotification', res.data)
                return res
            })
            .catch((err: AxiosError) => {
                console.log(err)
            })
    }

    @Action({rawError: true})
    public statusUpdate(notification: any): void{
        const api = `${process.env.VUE_APP_BASE_API_URL}/Notifications`;
        return Vue.$net
            .post(api, notification.data)
            .then((res: any) => {
                // this.context.commit('setAllNotification', notification.list)
                return res
            })
            .catch((err: AxiosError) => {
                console.log(err)
            })
    }

    @Action({ rawError: true })
    public deleteNotification(notificationId: string): void {
        
        const api = `${process.env.VUE_APP_BASE_API_URL}/Notifications/${notificationId}`;

        return Vue.$net
            .delete(api)
            .then((res: AxiosResponse) => {
                this.context.commit('setAllNotification', res.data)
                return res
            })
            .catch((err: AxiosError) => {
                console.log(err)
            })
    }

}

export default Notification